import React from 'react';


import component, {classnames} from './component';


export default component('TopHeader', function({className, children, left, justifyCenter}) {
  return <h1 className={classnames(className, 'TopHeader', {'TopHeader--Left': left, 'TopHeader--Center': justifyCenter})}>
    {children}
  </h1>;
});



// WEBPACK FOOTER //
// ./src/components/TopHeader.js